import { addHours, addMinutes, parse, roundToNearestMinutes } from "date-fns";

import { DateFormat } from "common/helpers/Format";

/**
 * Formats a Date as a date-only `YYYY-MM-DD` string using its LOCAL calendar parts. Used when
 * serializing date-only fields to rsf-api (`estimated_start`/`estimated_end`) so the day never
 * shifts across a timezone boundary the way `toISOString()` (UTC) would. Round-trips with the
 * `estimateFromJSON` factory, which parses the string at local midnight.
 *
 * @param date - the Date to format
 * @returns the `YYYY-MM-DD` string
 */
export const formatDateOnly = (date: Date): string => DateFormat(date, "shortDate-hyphenated");

export const checkDate = (date: Date | string | number): Date => {
  if (date instanceof Date) {
    return date;
  }

  return new Date(date);
};

export const toFormDate = (input: string | Date): Date => {
  if (typeof input === "string") {
    return input.length === 8 ? parse(input, "HH:mm:ss", new Date()) : new Date(input);
  }

  return input;
};

export const validAppointmentStartTime = (date = new Date()): Date => {
  const datePlusOneHour = addHours(date, 1);

  const rounded = roundToNearestMinutes(datePlusOneHour, { nearestTo: 15 });

  return rounded <= datePlusOneHour ? addMinutes(rounded, 15) : rounded;
};
